import Image from '@atlaskit/image';
import Link from '@atlaskit/link';
import { BreakpointsTable } from '@af/design-system-docs-ui';
import layoutAnatomy from "../../../../src/pages/foundations/grid/_assets/layout-anatomy-light.png";
import layoutAnatomyDark from "../../../../src/pages/foundations/grid/_assets/layout-anatomy-dark.png";
import gridAnatomy from "../../../../src/pages/foundations/grid/_assets/grid-anatomy-light.png";
import gridAnatomyDark from "../../../../src/pages/foundations/grid/_assets/grid-anatomy-dark.png";
import columnSpan from "../../../../src/pages/foundations/grid/_assets/column-span-light.png";
import columnSpanDark from "../../../../src/pages/foundations/grid/_assets/column-span-dark.png";
import columnOffset from "../../../../src/pages/foundations/grid/_assets/column-offset-light.png";
import columnOffsetDark from "../../../../src/pages/foundations/grid/_assets/column-offset-dark.png";
import gridBasicsDo from "../../../../src/pages/foundations/grid/_assets/grid-basics-do-light.png";
import gridBasicsDoDark from "../../../../src/pages/foundations/grid/_assets/grid-basics-do-dark.png";
import gridBasicsDont from "../../../../src/pages/foundations/grid/_assets/grid-basics-dont-light.png";
import gridBasicsDontDark from "../../../../src/pages/foundations/grid/_assets/grid-basics-dont-dark.png";
import spacingTokens from "../../../../src/pages/foundations/grid/_assets/spacing-tokens-light.png";
import spacingTokensDark from "../../../../src/pages/foundations/grid/_assets/spacing-tokens-dark.png";
import contentContainers from "../../../../src/pages/foundations/grid/_assets/content-containers-light.png";
import contentContainersDark from "../../../../src/pages/foundations/grid/_assets/content-containers-dark.png";
import alignContentDo from "../../../../src/pages/foundations/grid/_assets/align-content-do-light.png";
import alignContentDoDark from "../../../../src/pages/foundations/grid/_assets/align-content-do-dark.png";
import alignContentDont from "../../../../src/pages/foundations/grid/_assets/align-content-dont-light.png";
import alignContentDontDark from "../../../../src/pages/foundations/grid/_assets/align-content-dont-dark.png";
import nestedGrid from "../../../../src/pages/foundations/grid/_assets/nested-grid-light.png";
import nestedGridDark from "../../../../src/pages/foundations/grid/_assets/nested-grid-dark.png";
import gridBreakpoints from "../../../../src/pages/foundations/grid/_assets/grid-breakpoints-light.png";
import gridBreakpointsDark from "../../../../src/pages/foundations/grid/_assets/grid-breakpoints-dark.png";
import gridTypes from "../../../../src/pages/foundations/grid/_assets/grid-types-light.png";
import gridTypesDark from "../../../../src/pages/foundations/grid/_assets/grid-types-dark.png";
import fixedGridTypes from "../../../../src/pages/foundations/grid/_assets/fixed-grid-types-light.png";
import fixedGridTypesDark from "../../../../src/pages/foundations/grid/_assets/fixed-grid-types-dark.png";
import fixedWideDo from "../../../../src/pages/foundations/grid/_assets/fixed-wide-do-light.png";
import fixedWideDoDark from "../../../../src/pages/foundations/grid/_assets/fixed-wide-do-dark.png";
import fixedWideDont from "../../../../src/pages/foundations/grid/_assets/fixed-wide-dont-light.png";
import fixedWideDontDark from "../../../../src/pages/foundations/grid/_assets/fixed-wide-dont-dark.png";
import fixedNarrowDo from "../../../../src/pages/foundations/grid/_assets/fixed-narrow-do-light.png";
import fixedNarrowDoDark from "../../../../src/pages/foundations/grid/_assets/fixed-narrow-do-dark.png";
import fixedNarrowDont from "../../../../src/pages/foundations/grid/_assets/fixed-narrow-dont-light.png";
import fixedNarrowDontDark from "../../../../src/pages/foundations/grid/_assets/fixed-narrow-dont-dark.png";
import fluidDo from "../../../../src/pages/foundations/grid/_assets/fluid-do-light.png";
import fluidDoDark from "../../../../src/pages/foundations/grid/_assets/fluid-do-dark.png";
import fluidDont from "../../../../src/pages/foundations/grid/_assets/fluid-dont-light.png";
import fluidDontDark from "../../../../src/pages/foundations/grid/_assets/fluid-dont-dark.png";
import applyingGrid from "../../../../src/pages/foundations/grid/_assets/applying-grid-light.png";
import applyingGridDark from "../../../../src/pages/foundations/grid/_assets/applying-grid-dark.png";
import gridSpanDo from "../../../../src/pages/foundations/grid/_assets/grid-span-do-light.png";
import gridSpanDoDark from "../../../../src/pages/foundations/grid/_assets/grid-span-do-dark.png";
import gridSpanDont from "../../../../src/pages/foundations/grid/_assets/grid-span-dont-light.png";
import gridSpanDontDark from "../../../../src/pages/foundations/grid/_assets/grid-span-dont-dark.png";
import breakpointSettingDo from "../../../../src/pages/foundations/grid/_assets/breakpoint-setting-do-light.png";
import breakpointSettingDoDark from "../../../../src/pages/foundations/grid/_assets/breakpoint-setting-do-dark.png";
import breakpointSettingDont from "../../../../src/pages/foundations/grid/_assets/breakpoint-setting-dont-light.png";
import breakpointSettingDontDark from "../../../../src/pages/foundations/grid/_assets/breakpoint-setting-dont-dark.png";
import breakpointViewportDo from "../../../../src/pages/foundations/grid/_assets/breakpoint-viewport-do-light.png";
import breakpointViewportDoDark from "../../../../src/pages/foundations/grid/_assets/breakpoint-viewport-do-dark.png";
import breakpointViewportDont from "../../../../src/pages/foundations/grid/_assets/breakpoint-viewport-dont-light.png";
import breakpointViewportDontDark from "../../../../src/pages/foundations/grid/_assets/breakpoint-viewport-dont-dark.png";
import autoLayoutDo from "../../../../src/pages/foundations/grid/_assets/auto-layout-do-light.png";
import autoLayoutDoDark from "../../../../src/pages/foundations/grid/_assets/auto-layout-do-dark.png";
import autoLayoutDont from "../../../../src/pages/foundations/grid/_assets/auto-layout-dont-light.png";
import autoLayoutDontDark from "../../../../src/pages/foundations/grid/_assets/auto-layout-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  Link,
  BreakpointsTable,
  layoutAnatomy,
  layoutAnatomyDark,
  gridAnatomy,
  gridAnatomyDark,
  columnSpan,
  columnSpanDark,
  columnOffset,
  columnOffsetDark,
  gridBasicsDo,
  gridBasicsDoDark,
  gridBasicsDont,
  gridBasicsDontDark,
  spacingTokens,
  spacingTokensDark,
  contentContainers,
  contentContainersDark,
  alignContentDo,
  alignContentDoDark,
  alignContentDont,
  alignContentDontDark,
  nestedGrid,
  nestedGridDark,
  gridBreakpoints,
  gridBreakpointsDark,
  gridTypes,
  gridTypesDark,
  fixedGridTypes,
  fixedGridTypesDark,
  fixedWideDo,
  fixedWideDoDark,
  fixedWideDont,
  fixedWideDontDark,
  fixedNarrowDo,
  fixedNarrowDoDark,
  fixedNarrowDont,
  fixedNarrowDontDark,
  fluidDo,
  fluidDoDark,
  fluidDont,
  fluidDontDark,
  applyingGrid,
  applyingGridDark,
  gridSpanDo,
  gridSpanDoDark,
  gridSpanDont,
  gridSpanDontDark,
  breakpointSettingDo,
  breakpointSettingDoDark,
  breakpointSettingDont,
  breakpointSettingDontDark,
  breakpointViewportDo,
  breakpointViewportDoDark,
  breakpointViewportDont,
  breakpointViewportDontDark,
  autoLayoutDo,
  autoLayoutDoDark,
  autoLayoutDont,
  autoLayoutDontDark,
  React
};